import _ from 'lodash';

export const hasCharacterPermission = (service_permission = []) => {
  return !_.isEmpty(service_permission) && _.isArray(service_permission) && service_permission.includes('lab');
};